import { render, staticRenderFns } from "./AppUserProjects.vue?vue&type=template&id=b3e231ea"
import script from "./AppUserProjects.vue?vue&type=script&lang=js"
export * from "./AppUserProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports